const currentYear = new Date().getFullYear();

export const REPORTING_YEARS = Array.from(
  { length: currentYear - 2000 + 1 },
  (_, index) => {
    const year = currentYear - index;
    return { label: year.toString(), value: year.toString() };
  },
);

export const TOGGLE_TABLE_OPTIONS = [
  { label: "Monthly Summary", value: "monthlySummary" },
  { label: "Patient Reporting", value: "patientReporting" },
  { label: "Volunteer Reporting", value: "volunteersReporting" },
  { label: "Mileage Summary", value: "mileageSummary" },
  { label: "Special 5% Report", value: "special5PercentReport" },
  { label: "Volunteer Retention Report", value: "volunteerRetention" },
  { label: "Measures of Excellence", value: "measuresOfExcellent" },
];

export const ELEVENTH_HOUR_REPORT_OPTION = {
  label: "11th Hour Reporting",
  value: "eleventhHour",
};

export const EXPANDED_ROWS_INITIAL = {
  monthlySummary: null,
  volunteerReporting: null,
  directCare: null,
  indirectCare: null,
};

export const CONFIG_KEYS = {
  DASHBOARD_DATA: "niramaya.dashboarddata.keys",
  MONTHS: "niramaya.data.months",
  QUARTER: "niramaya.data.quarter",
  MAPPER: "niramaya.reporting.logs.keys.mapper",
};

export const CLICKABLE_REPORT_CATEGORY_KEYS = [
  "totalNewVolunteers",
  "turnoverNewVolunteers",
  "turnoverOldVolunteers",
  "totalActiveVolunteers",
  "totalVolunteer",
  "directVolunteer",
  "indirectVolunteer",
  "noHoursVolunteer",
  "totalAdministrativeVolunteer",
  "totalPatientsServed",
  "totalNewPatientsServed",
  "patientDeathsOrDischarges",
  "generalVolunteer",
  "patientServed",
];
